module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_9006.edd59d44.png";